<template>
  <header id="header" class="header" role="banner">
<!--    {{user.role}}-->
    <nav class="navbar navbar-expand-lg navbar-dark">
      <div id="user">
        <span @click.prevent.stop="isDropdownOpen = !isDropdownOpen">
          <span class="text-light-grey">{{ $t('message.vitamins') }}</span>
        <span class="text-light-grey text-lowercase">{{ $t('message.for') }}</span>
        <strong id="user-name" class="font-style-5 text-light-grey">
          {{user ? user.fullname : ''}}
        </strong>
        </span>

        <nav class="d-inline top-menu">
          <button class="btn btn-link p-0" @click.prevent.stop="isDropdownOpen = !isDropdownOpen">
            <span v-show="!isDropdownOpen" class="openicon"><i class="fas fa-fw fa-caret-down"></i></span>
            <span v-show="isDropdownOpen" class="openicon"><i class="fas fa-fw fa-caret-up"></i></span>
          </button>
          <ul class="dropdown" v-show="isDropdownOpen">
            <router-link active-class="active" tag="li" to="/profile" class="pl-2">
              <i class="fa-sm fa-fw fas fa-user-cog"></i>
              <span class="btn-h btn">{{ $t('message.preferences') }}</span>
            </router-link>
            <!--            {{siteTheme}}-->
            <li class="pl-2 " @click="themeSwitch">
              <span v-show="storeTheme === 'lightmode'">
                <i class="fa-sm fa-fw far fa-moon"></i>
                <span class="btn-h btn">{{ $t('message.dark_mode') }}</span></span>
              <span v-show="storeTheme !== 'lightmode'">
                <i class="fa-sm fa-fw far fa-sun"></i>
                <span class="btn-h btn">{{ $t('message.light_mode') }}</span></span>
            </li>


            <li v-if="isManager || user.role.name === 'HR'"
                @click.prevent="switchView('user')"
                class="pl-2 user-switches"
                :class="this.mode === 'user' ? 'active':''">
              <i class="fa-sm fas fa-fw fa-user"></i>
              <button class="btn-h btn">User</button>
            </li>
            <li v-if="isManager" @click.prevent="switchView('manager')"
                class="pl-2"
                :class="this.mode === 'manager' ? 'active':''">
              <i class="fa-sm fas fa-fw fa-users"></i>
              <button class="btn-h btn">{{ $t('message.manager') }}</button>
            </li>
            <li v-if="user.role.name === 'HR'" @click.prevent="switchView('hr')" class="pl-2"
                :class="this.mode === 'hr' ? 'active':''">
              <i class="fa-sm fas fa-fw fa-id-card"></i>
              <button class="btn-h btn">{{ $t('message.hr') }}</button>
            </li>
            <router-link active-class="active" v-if="user.role.name === 'HR'" tag="li" to="/company"
                         class="pl-2 user-switches">
              <i class="fa-sm fa-fw fas fa-cog"></i>
              <button class="btn-h btn">{{ $t('message.company_settings') }}</button>
            </router-link>


          </ul>
        </nav>

      </div>
      <div id="company">
        <span class="font-style-2 text-green">{{ $t('message.vitamins') }}</span> <span
        class="text-lowercase font-style-2 for" v-if="company && company.Logo">{{ $t('message.for') }}</span>
        <!--        <img id="company-logo" class="img-fluid" src="@/assets/images/logo.svg" alt="Logo Destiny"></div>-->
        <img v-if="company && company.Logo" id="company-logo" class="img-fluid" :src="url + company.Logo.url" alt="Logo company"></div>
      <div class="switch-role">
      </div>
      <div class="locale-changer small">
        {{$t('message.language')}}:
        <select @change="changeLang" style="text-transform: uppercase" v-model="$i18n.locale" class="border-0 styled-input m-0 lang-select">
          <option style="border:0; text-transform: uppercase" v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
            {{ lang }}
          </option>
        </select>
      </div>
    </nav>
  </header>
</template>

<script>
  import store from "../store/store";
  // import axios from "./../axios-auth";
  import {eventPath} from "../polyfills";

  export default {

    data() {
      return {
        langs: ['en', 'nl', 'fr'],
        isDropdownOpen: false,
        store,
        mode: store.state.viewMode,
        user: null,
        theme: '',
        // isManager:false,
      }
    },
    created() {
      this.initMenuClick();


      this.user = store.getters.getUser;
      this.theme = store.getters.getTheme
    },

    computed: {
      // logo() {
      //   let c = this.company;
      //   return c ? (c.Logo ? this.url + c.Logo.url : false) : false
      // },
      company() {
        return store.getters.getCompany;
      },
      cMode() {
        return store.state.viewMode
      },
      storeTheme() {
        return store.state.theme
      },
      storeUser() {
        return store.state.user
      },
      isManager() {
        return this.storeUser.managesTeams.length > 0
      }
    },
    watch: {
      storeTheme() {
        this.theme = this.siteTheme
      },
      storeUser() {
        this.user = this.storeUser
      },
      cMode() {
        this.mode = this.cMode
      }
    },
    methods: {
      themeSwitch(){
        this.toggleTheme();
        this.isDropdownOpen = !this.isDropdownOpen
      },
      initMenuClick() {
        document.querySelector("body").addEventListener("mouseup", (e) => {
          const el = this.$el.querySelector('.dropdown');
          if (eventPath(e).includes(el)) {
          } else {
            this.isDropdownOpen = false
          }
        });
      },
      changeLang(e) {
        let lang = e.target.value;
        //   console.log('change lang to', lang)
        store.dispatch("setLang", {lang:lang,fp:this.fp});
      },
      switchView(type) {
        store.dispatch('switchView', type);
        if (type == 'user') {
          this.$router.push('/');
        }
        if (type == 'hr') {
          this.$router.push('/dashboard-hr');
        }
        if (type == 'manager') {
          this.$router.push('/dashboard-manage');
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Header.vue